export default __webpack_public_path__ + "static/media/bell-active.25319f91.svg";